import { Link } from "react-router-dom";
import { getCategories } from "@/utils/news";

export default function CategoryQuickLinks() {
  const categories = getCategories();
  return (
    <section className="w-full">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex items-center gap-4 bg-background-50 border border-background-200 rounded-lg p-5 hover:border-primary-300 transition-colors cursor-pointer"
          >
            <span className="w-12 h-12 shrink-0 flex items-center justify-center rounded-md bg-primary-50 text-primary-600 text-2xl group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
              <i className={cat.icon}></i>
            </span>
            <span className="min-w-0">
              <span className="block font-heading font-bold text-foreground-950 text-base">
                {cat.name}
              </span>
              <span className="block text-xs text-foreground-500 mt-1 line-clamp-1">
                {cat.description}
              </span>
            </span>
            <i className="ri-arrow-right-line ml-auto text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
          </Link>
        ))}
      </div>
    </section>
  );
}